import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import {useState} from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

function CrosswordQuestionAndAnswerInput() {
  const [numberOfRows, setNumberOfRows] = useState(5)

  return <>
    {Array.apply(null, Array(numberOfRows)).map(row => {
      return <Stack direction="row" spacing={2}>
        <TextField
          required
          id="crossword-input-clue"
          label="Clue"
          defaultValue="God of cricket"
        />
        <TextField
          required
          id="crossword-input-answer"
          label="Answer"
          defaultValue="Sachin"
        />
        <DeleteIcon style={{paddingTop: 20}}/>
      </Stack>
    })}

    <Button
      startIcon={<AddIcon/>}
      onClick={() => {
        setNumberOfRows(numberOfRows + 1)
      }}>Add option</Button>

  </>
}

export default CrosswordQuestionAndAnswerInput
